import { markForScrub, removeFromMissingQueue, updateTerminalScan, revertToMissingQueue } from "../api/ScrubUpdateAPI";
import {TERMINAL_SCAN_BREACHED_RESPONSE, UNAUTHORISED_USER} from "../constants/ScrubConstants";
import {HTTP_STATUS_CODE} from "../constants/CommonConstants";


export const initialButtonState = {
    status: "idle",
    removeMissingStatus: "idle",
    reviewMissingStatus: "idle",
    removeMissingStatusConfirm: "idle",
    enable: true,
    terminalScans: [],
    terminalScanTTs: [],
    removeMissingMessage: "",
    reviewMissingStatusConfirm: [],
    rmEnable: true,
    failedItems: [],
    metaDataInvocation: null
};

export const ScrubUpdateReducer = (state = initialButtonState, action) => {
    switch (action.type) {
        case "MARK_PACKAGES":
            let {targetUseCase, allItems, dispatcher, allItemsObject} = action.data;
            markForScrub({targetUseCase, allItems, allItemsObject}, dispatcher);
            return {...state, status:"loading" , failedItems: []}
        case "SET_STATUS":
            return {
                ...state,
                status: action.data,
                failedItems: (action.additionalInfo
                    && action.additionalInfo.errorCode === TERMINAL_SCAN_BREACHED_RESPONSE) ? action.additionalInfo.failedItems : [] };
        case "TOGGLE_BUTTON":
            return { ...state, enable: !state.enable }
        case "TOGGLE_RM_BUTTON":
            return { ...state, rmEnable: !state.rmEnable }
        case "ENABLE_BUTTON":
            return { ...state, enable: true }
        case "ENABLE_RM_BUTTON":
            return { ...state, rmEnable: true }
        case "SET_REMOVE_MISSING_STATUS":
            return { ...state, removeMissingStatus: action.data, removeMissingMessage: "" };
        case "SET_REVIEW_MISSING_STATUS":
            return { ...state, reviewMissingStatus: action.data };
        case "SET_TERMINAL_SCANS":
            return { ...state, terminalScans: action.data };
        case "SET_TERMINAL_SCAN_TT":
            return { ...state, terminalScanTTs: action.data };
        case "REMOVE_PACKAGES_FROM_MISSING_QUEUE":
            removeFromMissingQueue(action.data.itemsToUpdate, action.data.dispatcher);
            return {...state, removeMissingStatusConfirm: "loading"};
        case "REMOVE_MISSING_UPDATED":
            return {...state, removeMissingStatus: "idle",
                removeMissingStatusConfirm: "idle",
                removeMissingMessage: action.data.message,
                ...handleUnauthorizedError(action.data.errorCode)
            };
        case "REMOVE_MISSING_MESSAGE":
            return {...state,
                removeMissingMessage: ""};
        case "UPDATE_SCAN":
            updateTerminalScan(
                action.data.scannableIds,
                action.data.targetStatus,
                action.data.shipmentType,
                action.data.dispatcher,
                action.data.reviewMissingStatusConfirm);
            let reviewMissingStatusConfirmScan = action.data.reviewMissingStatusConfirm;
            reviewMissingStatusConfirmScan[action.data.scannableId] = "loading";
            return {...state, reviewMissingStatusConfirm: reviewMissingStatusConfirmScan};
        case "REVERT_TO_MISSING_QUEUE":
            revertToMissingQueue(
                action.data.itemsToUpdate,
                action.data.dispatcher,
                action.data.reviewMissingStatusConfirm);
            let reviewMissingStatusConfirm = action.data.reviewMissingStatusConfirm;
            reviewMissingStatusConfirm[action.data.scannableId] = "loading";
            return {...state, reviewMissingStatusConfirm: reviewMissingStatusConfirm}
        case "REVERT_TO_MISSING_QUEUE_UPDATED":
            return {
                ...state,
                reviewMissingStatusConfirm: action.data.reviewMissingStatusConfirm,
                ...handleUnauthorizedError(action.data.errorCode)
            };
        case "UNAUTHORISED_USER":
            return { ...state, status: action.data, metaDataInvocation: {messageStringId: UNAUTHORISED_USER}}
        default:
            return state
    }
};

/**
 * Method to handle the unauthorised exceptions
 * @param errorCode
 * @returns {{status: string, metaDataInvocation: {messageStringId: string}}|{}}
 */
function handleUnauthorizedError(errorCode) {
    return errorCode === HTTP_STATUS_CODE.UNAUTHORISED_RESPONSE_CODE ? {
        status: UNAUTHORISED_USER,
        metaDataInvocation: {messageStringId: UNAUTHORISED_USER}
    } : {};
}


// WEBPACK FOOTER //
// ./src/commons/reducer/ScrubUpdateReducer.js